import { render, staticRenderFns } from "./AddTestResult.vue?vue&type=template&id=79898774&scoped=true&"
import script from "./AddTestResult.vue?vue&type=script&lang=js&"
export * from "./AddTestResult.vue?vue&type=script&lang=js&"
import style0 from "./AddTestResult.vue?vue&type=style&index=0&id=79898774&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79898774",
  null
  
)

export default component.exports